var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileCsv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    "data-stroke": "none",
    fill: "#444",
    d: "M24.9 39.2c-.7 0-1.3.3-1.7.8s-.6 1.3-.6 2.3c0 2.1.8 3.1 2.3 3.1.7 0 1.4-.2 2.4-.5v1.7c-.8.3-1.6.5-2.6.5-1.4 0-2.4-.4-3.1-1.2-.7-.8-1.1-2-1.1-3.5 0-1 .2-1.8.5-2.5s.9-1.3 1.5-1.7c.7-.4 1.4-.6 2.3-.6.9 0 1.8.2 2.7.7l-.5 1.5c-.3-.2-.7-.3-1-.4s-.8-.2-1.1-.2zM35 44.4c0 .8-.3 1.5-.9 2-.6.5-1.4.7-2.5.7-1 0-1.9-.2-2.6-.6v-1.8c.6.3 1.2.5 1.6.6.4.1.8.2 1.2.2.4 0 .8-.1 1-.2.2-.2.3-.4.3-.7 0-.2-.1-.3-.2-.5s-.3-.3-.4-.4l-1.2-.6c-.6-.3-1-.5-1.3-.8s-.5-.5-.7-.9c-.2-.4-.3-.7-.3-1.2 0-.8.3-1.5.8-1.9.6-.5 1.3-.7 2.3-.7.5 0 .9.1 1.4.2.4.1.9.3 1.4.5l-.6 1.5c-.5-.2-.9-.3-1.2-.4-.3-.1-.6-.1-1-.1s-.7.1-.9.3-.2.3-.2.6c0 .2 0 .3.1.5s.2.3.4.4c.2.1.6.3 1.2.7.9.4 1.5.8 1.8 1.2s.5.8.5 1.4zM42.2 37.7h2L41.1 47H39l-3.1-9.3h2l1.7 5.5c.1.3.2.7.3 1.1.1.4.2.7.2.9 0-.4.2-1.1.5-2l1.6-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    fill: "none",
    stroke: "#444",
    strokeMiterlimit: 10,
    d: "M40 2v16h16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#444",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    d: "M56 32V18L40 2H8v30M8 53v9h48v-9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    fill: "none",
    stroke: "#444",
    strokeMiterlimit: 10,
    d: "M61 32H3M8 27l-5 5v21h58V32l-5-5"
  }))));
}

export default SvgFileCsv;